// Sending a command to a device — port of Flutter's devController().
//
// TWO TRANSPORTS, chosen by connectivity:
//
//   online   MQTT  `[<uno>]<message>#<userId>` on topic `<uno>/device`
//   offline  BLE   the bare command written to the device's 0xFF01 characteristic
//
// The BLE leg is what keeps a house usable with no internet: the firmware takes
// the same command strings over Bluetooth that it takes over MQTT ("1-1",
// "alloff", …), so the caller doesn't care which path was used.
//
// publishCommand stays SYNCHRONOUS for the online case, because every control
// screen calls it in a tap handler and expects no await. The BLE fallback is
// fired off in the background instead of changing that signature.

import { publishMessage } from '../mqtt/mqttClient';
import { isOffline } from '../offline/offlineMode';
import { bleSupported } from '../ble/bleClient';
import { sendControlOverBle } from '../ble/bleControl';

// Set by the UI so a failed offline send can say something useful.
let notify = null;
export function setControlNotifier(fn) { notify = fn; }

function overBle(uniqueNumber, message) {
  if (!bleSupported()) {
    if (notify) notify('No internet connection.');
    return;
  }
  sendControlOverBle(uniqueNumber, message).then((ok) => {
    if (!ok && notify) {
      notify('Device not reachable over Bluetooth. Move closer and try again.');
    }
  });
}

export function publishCommand(uniqueNumber, message, userId) {
  const payload = `[${uniqueNumber}]${message}#${userId}`;
  // Offline: MQTT cannot reach the broker, so the publish would silently vanish
  // into a disconnected client. Go over BLE instead.
  if (isOffline()) {
    overBle(uniqueNumber, message);
    return payload;
  }
  publishMessage(`${uniqueNumber}/device`, payload);
  return payload;
}

// Publish a message with NO `[uno]…#userId` envelope.
//
// Some firmware commands are sent raw — in Flutter, devController() skips the
// envelope whenever it is called with a `buttonId`, which is how `getallwifi`
// goes out. Same topic either way; only the payload differs.
export function publishRaw(uniqueNumber, message) {
  if (isOffline()) {
    overBle(uniqueNumber, message);
    return message;
  }
  publishMessage(`${uniqueNumber}/device`, message);
  return message;
}
